module.exports = __webpack_public_path__ + "static/media/person1.07f4d673.jpg";